"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const mobx_react_1 = require("mobx-react");
const ConfigurationMFA_1 = __importDefault(require("@Scenes/UserRegistrationScenes/CreatePasswordScene/ConfigurationMFA"));
const create_password_status_1 = require("@App/enum/create-password-status");
const ConfirmSMSCode_1 = __importDefault(require("@Scenes/UserRegistrationScenes/CreatePasswordScene/ConfirmSMSCode"));
const contexts_1 = require("@App/contexts");
const react_router_dom_1 = require("react-router-dom");
const EnrollMFAScene = () => {
    const { createPasswordStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const path = (0, react_router_dom_1.useLocation)();
    const isMfaReset = path.pathname === '/enroll-mfa';
    const getComponent = () => {
        switch (createPasswordStore.createPasswordStatus) {
            case create_password_status_1.CreatePasswordStatus.confirm_sms_code:
                return react_1.default.createElement(ConfirmSMSCode_1.default, { loading: false, setLoading: () => { } });
            case create_password_status_1.CreatePasswordStatus.config_done:
                return !isMfaReset ? (react_1.default.createElement("div", { className: "global-container" },
                    react_1.default.createElement("div", { className: "after-mfa-confirmed" },
                        react_1.default.createElement("h3", null, "Password set!"),
                        react_1.default.createElement("p", null, "Your personal user account password has been set successfully."),
                        react_1.default.createElement(react_router_dom_1.NavLink, { to: '/login' }, "Go to Portal")))) : (react_1.default.createElement("div", { className: "global-container" },
                    react_1.default.createElement("div", { className: "after-mfa-confirmed" },
                        react_1.default.createElement("h3", null, "MFA Settings Updated"),
                        react_1.default.createElement("p", null, "You will now need to login to The MLC Portal using your new MFA type by clicking the link below."),
                        react_1.default.createElement(react_router_dom_1.NavLink, { to: '/login' }, "Go to Portal"))));
            default:
                return react_1.default.createElement(ConfigurationMFA_1.default, { loading: false, setLoading: () => { }, isLoggingIn: true });
        }
    };
    return react_1.default.createElement("div", { className: "enroll-mfa-scene" }, getComponent());
};
exports.default = (0, mobx_react_1.observer)(EnrollMFAScene);
